import {useState} from 'react';
import Validations from '../../../AppValidation';
import {objAttributes, objAttDireccion, objInteresadoPCT3} from './pageAltaUsuarioData';
import AuthProvider from './../../../providers/authProvider';
import {properties as propertiesCloudConfig } from './../../../config/Config';
import { codigoPais } from 'AppData';

/**
 * Importación de las validaciones
 */
const { validation, requiredValidationUndefined, objValidations, requiredValidationSelects, validationDate } = Validations();

/**
 * @constant formatDate formatea la fecha que se inserta por parámetro para adaptarla al formato (dd/mm/yyyy)
 * @param {*} value recibe la fecha
 */
const formatDate = (value) => {
    const date = new Date(value);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    return (
        day + '/' + month + '/' + year
    )
};

/**
 * @constant onBlur devuelve el valor de una variable en formato booleano dependiendo si el campo a evaluar
 * es válido (devolverá true) o es inválido (devolverá false)
 * @param {*} e 
 * @param {*} valueToEvaluate el valor a evaluar
 * @param {*} typeValidation tipo de validación a la que se someterá el valor insertado
 */
const onBlur = (/*e,*/ valueToEvaluate, typeValidation) => {
    let valor = true
    if (requiredValidationUndefined(valueToEvaluate)) {//Evalua si el campo NO está vacío
        if (!validation(valueToEvaluate, typeValidation)) {//Evalua si el valor NO es válido
            if (valueToEvaluate === ''/* || valueToEvaluate === undefined*/) {//Si no se inicializa el contenido del valor, el valor será undefined, una vez cambie este se inicializa la variable
                return (valor)
            } else {
                return (false)
            }
        } else {
            return (valor)//Si es válido
        }
    } else {
        return (valor)
    }
}
/**
 * @constant useForm contiene las variables que serán devueltas al formulario para que sean tratadas
 */
const useForm = () => {    

    /**
     * @constant objFields objeto que contiene todos los campos del formulario y sirve para manejar sus valores y estado.
     */
    const objFields = {
    // Interesado
    'nifInteresado': '',
    'nombreInteresado': '',
    'apellido1Interesado': '',
    'apellido2Interesado': '',
    'fechaNacimientoInteresado': '',
    'emailInteresado': '',
    'telefonoInteresado': '',
    'telefonoMovilInteresado': '',
    'sexoInteresado': '',
    'nombreDomicilioInteresado': '',
    'numeroDomicilioInteresado': '',
    'pisoDomicilioInteresado': '',
    'puertaDomicilioInteresado': '',
    'letraDomicilioInteresado': '',
    'escaleraDomicilioInteresado': '',
    'codigoPostalDomicilioInteresado': '',
    'tipoViaDomicilioInteresado': null,
    'provinciaDomicilioInteresado': null,
    'municipioDomicilioInteresado': null,
    'paisDomicilioInteresado': null,
    
    //Entidad
    'entidadRazonSocialEntidadRepresentada': null,
    'cifEntidadRepresentada': null,
    'emailEntidadRepresentada': '',
    'telefonoEntidadRepresentada': '',
    'telefonoMovilEntidadRepresentada': '',
    'nombreDomicilioEntidadRepresentada': '',
    'numeroDomicilioEntidadRepresentada': '',
    'pisoDomicilioEntidadRepresentada': '',
    'puertaDomicilioEntidadRepresentada': '',
    'letraDomicilioEntidadRepresentada': '',
    'escaleraDomicilioEntidadRepresentada': '',
    'codigoPostalDomicilioEntidadRepresentada': '',
    'tipoViaDomicilioEntidadRepresentada': null,
    'provinciaDomicilioEntidadRepresentada': null,
    'municipioDomicilioEntidadRepresentada': null,
    'paisDomicilioEntidadRepresentada': null,

    'idInteresado':null,
    'idDatoscontactoInteresado':null,
    'idEntidad':null,
    'idDatoscontactoEntidad':null,

    //PCT3
    'tipoInteresado': null,
    'tipoIdentificador': '',
    'tipoNotificacion': ''
    };

    /**
     * Constaltes par alos campos
     */
    const [values, setValues] = useState({
        ...objFields,
    });

    const [dataFrom, setDataFrom] = useState(null);

    const handleChange = (e, newValue, idObjeto) => {
        if(idObjeto){
            //OBJECTS
            setValues({
                ...values,
                [idObjeto]: newValue
            });
            
            switch (idObjeto) {
                case objAttDireccion(true).descripcionTipoViaDomicilio.id:
                    setDescripcionTipoViaDomicilioInteresadoValid(requiredValidationSelects(newValue));
                break;

                case objAttributes.sexoInteresado.id:
                    setSexoValid(true);
                break;
            
                case objAttDireccion(true).nombreProvinciaDomicilio.id:
                    setNombreProvinciaInteresadoValid(requiredValidationSelects(newValue));
                break;
            
                case objAttDireccion(true).nombreMunicipioDomicilio.id:
                    setNombreMunicipioInteresadoValid(requiredValidationSelects(newValue));
                break;

                case objAttDireccion(true).nombrePaisDomicilio.id:
                    setPaisDomicilioInteresadoValid(requiredValidationSelects(newValue));

                    if (newValue.codigo === codigoPais.SPAIN) {
                        setValues({
                            ...values,
                            ['provinciaDomicilioInteresado']: null,
                            ['municipioDomicilioInteresado']: null,
                            ['codigoPostalDomicilioInteresado']: "",
                            [idObjeto]: newValue
                        });
                    }

                break;

            default:
                  
                break;
              }
            
        
        }else{
            //INPUT TEXT
            let identificadorCampo = e.target.id;

            if(identificadorCampo === ""){
            identificadorCampo = e.target.name;
            }

            setValues({
                ...values,
                [identificadorCampo]: e.target.value
            });              
        }     
    };
    
    /**
     * Constantes para almacenar el estado de las validaciones
     */
    const [showAlert, setShowAlert] = useState(false);
    const [dniValid, setDniValid] = useState(true);    
    const [nombreValid, setNombreValid] = useState(true);
    const [apellido1Valid, setApellido1Valid] = useState(true);
    const [fechaValid, setFechaValid] = useState(true);
    const [emailValid, setEmailValid] = useState(true);
    const [tlfMovilValid, setTlfMovilValid] = useState(true);
    const [tlfValid, setTlfValid] = useState(true);
    const [nombreDomicilioInteresadoValid, setNombreDomicilioInteresadoValid] = useState(true);
    const [numDomicilioInteresadoValid, setNumDomicilioInteresadoValid] = useState(true);
    const [numPisoInteresadoValid, setNumPisoInteresadoValid] = useState(true);
    const [sexoValid, setSexoValid] = useState(true);
    const [codigoPostalInteresadoValid, setCodigoPostalInteresadoValid] = useState(true);
    const [descripcionTipoViaDomicilioInteresadoValid, setDescripcionTipoViaDomicilioInteresadoValid] = useState(true);
    const [nombreProvinciaInteresadoValid, setNombreProvinciaInteresadoValid] = useState(true);
    const [nombreMunicipioInteresadoValid, setNombreMunicipioInteresadoValid] = useState(true);
    const [paisDomicilioInteresadoValid, setPaisDomicilioInteresadoValid] = useState(true);
    //Entidad representada
    const [cifValid, setcifValid] = useState(true);
    const [entidadRazonSocialEntidadRepresentadaValid, setEntidadRazonSocialEntidadRepresentada] = useState(true);
    const [emailValidEntidad, setEmailValidEntidad] = useState(true);
    const [tlfValidEntidad, setTlfValidEntidad] = useState(true);
    const [tlfMovilEntidad, setTlfMovilEntidad] = useState(true);
    const [tipoViaValidEntidad, setTipoViaValidEntidad] = useState(true);
    const [nombreViaValidEntidad, setNombreViaValidEntidad] = useState(true);
    const [numeroValidEntidad, setNumeroValidEntidad] = useState(true);
    const [pisoValidEntidad, setPisoValidEntidad] = useState(true);
    const [provinciaValidEntidad, setProvinciaValidEntidad] = useState(true);
    const [municipioValidEntidad, setMunicipioValidEntidad] = useState(true);
    const [codigoPostalValidEntidad, setCodigoPostalValidEntidad] = useState(true);

    /**
     * @constant Hook que almacena el mail de dpd
     */
    const [mailDPD, setMailDPD] = useState();

    const {checkCloudProperties} = AuthProvider();

    //Formateo de la fecha
    const formattedBirthday = formatDate(values.fechaNacimientoInteresado);
    
    /**
     * Transformar el objeto values a la estructura del back
     * para poder almacenarlo correctamente
     */
    const obtenerObjetoUsuario = () =>{
        values.municipioDomicilioInteresado.provincia = values.provinciaDomicilioInteresado;
        values.municipioDomicilioInteresado.provincia.pais = values.paisDomicilioInteresado;
        let usuario = {

            interesado: {
                id: values.idInteresado,
                codigo: null,
                nombre: values.nombreInteresado,
                apellido1: values.apellido1Interesado,
                apellido2: values.apellido2Interesado,
                nif: values.nifInteresado,
                fechaNacimiento: values.fechaNacimientoInteresado,
                fechaAlta: null,
                fechaBaja: null, 
                publico: false, 
                estado: null, 
                datosContacto:{
                    id: values.idDatoscontactoInteresado,
                    tipoVia: values.tipoViaDomicilioInteresado,
                    nombreVia: values.nombreDomicilioInteresado,
                    numero: values.numeroDomicilioInteresado!=="" ? values.numeroDomicilioInteresado : null,
                    piso: values.pisoDomicilioInteresado!=="" ? values.pisoDomicilioInteresado : null,
                    bloque: null, 
                    escalera: values.escaleraDomicilioInteresado!=="" ? values.escaleraDomicilioInteresado : null,
                    puerta: values.puertaDomicilioInteresado!=="" ? values.puertaDomicilioInteresado : null,
                    letra: values.letraDomicilioInteresado!=="" ? values.letraDomicilioInteresado : null,
                    codigoPostal: values.codigoPostalDomicilioInteresado,
                    municipio: modificarCodigoMunicipio(values.municipioDomicilioInteresado),
                    telefono: values.telefonoInteresado!=="" ? values.telefonoInteresado : null,
                    movil:values.telefonoMovilInteresado!=="" ? values.telefonoMovilInteresado : null,
                    fax: null, 
                    email: values.emailInteresado!=="" ? values.emailInteresado : null,
                },
                tipoIdentificacion: null,
                sexo: JSON.parse(values.sexoInteresado),
                anagramaFiscal: null
            },
            entidad:null
        }
        if(values.cifEntidadRepresentada){

            usuario.entidad = {
                id: values.idEntidad,
                codigo: null,
                nombre: values.entidadRazonSocialEntidadRepresentada,
                apellido1: '-', //El back no deja que sea null
                apellido2: null,
                nif: values.cifEntidadRepresentada,
                fechaNacimiento: null,
                fechaAlta: null,
                fechaBaja: null, 
                publico: false, 
                estado: null,
                datosContacto:{
                    id: values.idDatoscontactoEntidad,
                    tipoVia: values.tipoViaDomicilioInteresado,
                    nombreVia: values.nombreDomicilioInteresado,
                    numero: values.numeroDomicilioInteresado !== "" ? values.numeroDomicilioInteresado : null,
                    piso: values.pisoDomicilioInteresado !== "" ? values.pisoDomicilioInteresado : null,
                    bloque: null,
                    escalera: values.escaleraDomicilioInteresado !== "" ? values.escaleraDomicilioInteresado : null,
                    puerta: values.puertaDomicilioInteresado !== "" ? values.puertaDomicilioInteresado : null,
                    letra: values.letraDomicilioInteresado !== "" ? values.letraDomicilioInteresado : null,
                    codigoPostal: values.codigoPostalDomicilioInteresado,
                    municipio: values.municipioDomicilioInteresado,
                    telefono: null,
                    movil: null,
                    fax: null,
                    email: null,
                },
                tipoIdentificacion:null,
                sexo: null,
                anagramaFiscal: null
            }
        }

        return usuario;
    }    

    //Evento SCROLL
    const gotoElement = () =>
        window.scrollTo({
            top: (0,0),
            behavior: "smooth"
        });

    // Validación de los campos obligatorios
    const validarCamposObligatorios = () =>{

        let isValid = false;

        let dniValidacion = true;
        
        setDniValid(dniValidacion);

        let nombreValidacion = true;
        nombreValidacion = requiredValidationSelects(values.nombreInteresado);
        setNombreValid(nombreValidacion);

        let apellido1Validacion = true;
        apellido1Validacion = requiredValidationSelects(values.apellido1Interesado);
        setApellido1Valid(apellido1Validacion);

        let fechaValidacion = true;
        fechaValidacion = validationDate(formattedBirthday, objValidations.birthdate);
        setFechaValid(fechaValidacion);

        let sexoValidacion = true;
        sexoValidacion = requiredValidationSelects(values.sexoInteresado);
        setSexoValid(sexoValidacion);

        let nombreDomicilioInteresadoValidacion = true;
        nombreDomicilioInteresadoValidacion = requiredValidationSelects(values.nombreDomicilioInteresado);
        setNombreDomicilioInteresadoValid(nombreDomicilioInteresadoValidacion);

        let codigoPostalInteresadoValidacion = true;
        codigoPostalInteresadoValidacion = validation(values.codigoPostalDomicilioInteresado, objValidations.codigoPostal);
        setCodigoPostalInteresadoValid(codigoPostalInteresadoValidacion);

        let descripcionTipoViaDomicilioInteresadoValidacion = true;
        descripcionTipoViaDomicilioInteresadoValidacion = requiredValidationSelects(values.tipoViaDomicilioInteresado);
        setDescripcionTipoViaDomicilioInteresadoValid(descripcionTipoViaDomicilioInteresadoValidacion);

        let nombreMunicipioDomicilioInteresadoValidacion = true;
        nombreMunicipioDomicilioInteresadoValidacion = requiredValidationSelects(values.municipioDomicilioInteresado);
        setNombreMunicipioInteresadoValid(nombreMunicipioDomicilioInteresadoValidacion);

        let nombreProvinciaDomicilioInteresadoValidacion = true;
        nombreProvinciaDomicilioInteresadoValidacion = requiredValidationSelects(values.provinciaDomicilioInteresado);
        setNombreProvinciaInteresadoValid(nombreProvinciaDomicilioInteresadoValidacion);

        let paisDomicilioInteresadoValidacion = true;
        paisDomicilioInteresadoValidacion = requiredValidationSelects(values.paisDomicilioInteresado);
        setPaisDomicilioInteresadoValid(paisDomicilioInteresadoValidacion);

        if(dniValidacion && nombreValidacion && apellido1Validacion && fechaValidacion && sexoValidacion && emailValid && tlfValid
            && tlfMovilValid && numDomicilioInteresadoValid && numPisoInteresadoValid && codigoPostalInteresadoValidacion && nombreProvinciaDomicilioInteresadoValidacion 
            && nombreMunicipioDomicilioInteresadoValidacion && descripcionTipoViaDomicilioInteresadoValidacion && nombreDomicilioInteresadoValidacion && paisDomicilioInteresadoValidacion){
                isValid = true;
        } 

        if (values.cifEntidadRepresentada) {
            let cifValidacion = true;
            cifValidacion = validation(values.cifEntidadRepresentada, objValidations.cif)
            setcifValid(cifValidacion);
            
            let entidadRazonSociaEntidadRepresentadas = true;
            entidadRazonSociaEntidadRepresentadas = requiredValidationSelects(values.entidadRazonSocialEntidadRepresentada);
            setEntidadRazonSocialEntidadRepresentada(entidadRazonSociaEntidadRepresentadas);

            let tipoViaValidacion = true;
            tipoViaValidacion = requiredValidationSelects(values.tipoViaDomicilioEntidadRepresentada);
            setTipoViaValidEntidad(tipoViaValidacion);

            let nombreViaValid = true;
            nombreViaValid = requiredValidationSelects(values.nombreDomicilioEntidadRepresentada);
            setNombreViaValidEntidad(nombreViaValid);

            let pisoValid = true;
            pisoValid = validation(values.pisoDomicilioEntidadRepresentada, objValidations.numPiso);
            setPisoValidEntidad(pisoValid);

            let numeroValid = true;
            numeroValid = validation(values.numeroDomicilioEntidadRepresentada, objValidations.numeric);
            setNumeroValidEntidad(numeroValid);

            let provinciaValid = true;
            provinciaValid = requiredValidationSelects(values.provinciaDomicilioEntidadRepresentada);
            setProvinciaValidEntidad(provinciaValid);

            let municipioValid = true;
            municipioValid = requiredValidationSelects(values.municipioDomicilioEntidadRepresentada);
            setMunicipioValidEntidad(municipioValid);

            let codigoPostalValid = true;
            codigoPostalValid = validation(values.codigoPostalDomicilioEntidadRepresentada, objValidations.codigoPostal);
            setCodigoPostalValidEntidad(codigoPostalValid);

            if (dniValidacion && nombreValidacion && apellido1Validacion && fechaValidacion && sexoValidacion && emailValid && tlfValid
                && tlfMovilValid && numDomicilioInteresadoValid && numPisoInteresadoValid && codigoPostalInteresadoValidacion && nombreProvinciaDomicilioInteresadoValidacion 
                && nombreMunicipioDomicilioInteresadoValidacion && descripcionTipoViaDomicilioInteresadoValidacion && nombreDomicilioInteresadoValidacion
                && cifValidacion && entidadRazonSociaEntidadRepresentadas && tipoViaValidacion && nombreViaValid
                && pisoValid && numeroValid && provinciaValid && municipioValid && codigoPostalValid) {
                    isValid = true;
            } else{
                isValid = false;
            }
        }

        return isValid;
    }

    /**
     * @constant validationsOnBlur iserta el valor booleano devuelto en los 'setters' de los campos que son
     * válidados a través del evento onBlur
     */
    const validationsOnBlur = (e) => {
    
        /**Campos no obligatorios FALTAN SELECTORES Y SEXO*/
        switch (e.target.id) {
            case objAttributes.inputs.emailInteresado.id:
                setEmailValid(onBlur(values.emailInteresado, objValidations.email));
            break;

            case objAttributes.inputs.telefonoInteresado.id:
                setTlfValid(onBlur(values.telefonoInteresado, objValidations.phone));
            break;
            
            case objAttributes.inputs.fechaNacimientoInteresado.id:
                setFechaValid(validationDate(formattedBirthday, objValidations.birthdate));
            break;

            case objAttributes.inputs.telefonoMovilInteresadoInteresado.id:
                /*
                * Controlamos el primer dígito en caso de ser un teléfono móvil de España,
                * debe empezar por 6 0 7.
                */
                if (values.telefonoMovilInteresado) {
                    const esMas34 = values.telefonoMovilInteresado.startsWith("+34");
                    const esMas034 = values.telefonoMovilInteresado.startsWith("+034");
                    if (esMas34 || esMas034) {
                        setTlfMovilValid(onBlur(values.telefonoMovilInteresado, objValidations.mobileEspana));
                    } else {
                        setTlfMovilValid(onBlur(values.telefonoMovilInteresado, objValidations.mobilePhone));
                    }
                }else{
                    setTlfMovilValid(onBlur(values.telefonoMovilInteresado, objValidations.mobilePhone));
                }
            break;

            case objAttDireccion(true).nombreDomicilio.id:
                setNombreDomicilioInteresadoValid(requiredValidationSelects(values.nombreDomicilioInteresado));
            break;

            case objAttDireccion(true).numeroDomicilio.id:
                setNumDomicilioInteresadoValid(onBlur(values.numeroDomicilioInteresado, objValidations.numeric));
            break;

            case objAttDireccion(true).pisoDomicilio.id:
                setNumPisoInteresadoValid(onBlur(values.pisoDomicilioInteresado, objValidations.numPiso));
            break;

            case objAttDireccion(true).codigoPostalDomicilio.id:
                setCodigoPostalInteresadoValid(validation(values.codigoPostalDomicilioInteresado, objValidations.codigoPostal));
            break;

            //Entidad representante
            case objAttributes.inputs.emailEntidad.id:
                setEmailValid(onBlur(values.emailEntidad, objValidations.email));
            break;

            case objAttributes.inputs.telefonoEntidad.id:
                setTlfValid(onBlur(values.telefonoEntidad, objValidations.phone));
            break;
            
            case objAttributes.inputs.telefonoMovilEntidadInteresado.id:
                setTlfMovilValid(onBlur(values.telefonoMovilEntidad, objValidations.mobilePhone));
            break;

            case objAttDireccion(false).nombreDomicilio.id:
                setNombreDomicilioInteresadoValid(requiredValidationSelects(values.nombreDomicilioInteresado));
            break;

            case objAttDireccion(false).numeroDomicilio.id:
                setNumDomicilioInteresadoValid(onBlur(values.numeroDomicilioInteresado, objValidations.numeric));
            break;

            case objAttDireccion(false).pisoDomicilio.id:
                setNumPisoInteresadoValid(onBlur(values.pisoDomicilioInteresado, objValidations.numPiso));
            break;

            case objAttDireccion(false).codigoPostalDomicilio.id:
                setCodigoPostalInteresadoValid(validation(values.codigoPostalDomicilioInteresado, objValidations.codigoPostal));
            break;

            default:
              //Declaraciones ejecutadas cuando ninguno de los valores coincide con el valor de la expresión
            break;
          }
    }
    /**
     * @function addValuesToObjetc Función que añade valores a un objeto u objetos contenidos en un array
     * @param {*} objeto Array de objetos u objeto al que se le van a añadir los valores
     * @param {*} addValues Array que contiene el/los objeto/s a añadir al objeto original
     * @returns 
     */
     const addValuesObjetc = (objeto, addValues) => {
        //Estructura de control que comprueba si el objeto original al que se le va a añadir los valores es un array de objetos o un objeto

        // Array de objetos
        if (Array.isArray(objeto)) {
            //Paso 1. Se recorre el array de objetos
            for (const valorObjeto of objeto) {

                //Paso 2. Se recorre el array que contiene los valores a añadir al objeto y se añaden
                for (const valor of addValues) {
                    Object.assign(valorObjeto, valor);
                }
            }
        // Objeto
        } else {
            //Paso 1. Se recorre el array que contiene los valores a añadir al objeto y se añaden
            for (const valor of addValues) {
                Object.assign(objeto, valor);
            }
        }
        return objeto;
    }

    /*************** FUNCIONES PCT3 ***************/
    
    /**
     * @function removeValuesObject Función que eliminar valores de un objeto u objetos contenidos en un array
     * @param {*} objeto 
     * @param {*} deleteValues 
     * @returns 
     */
    const removeValuesObject = (objeto, deleteValues) => {
        //Estructura de control que comprueba si el objeto original al que se le va a añadir los valores es un array de objetos o un objeto
        
        // Array de objetos
        if (Array.isArray(objeto)) {   
            //Paso 1. Recorre el array de objetos     
            for (const valorObjeto of objeto) {

                //Paso 2. Recorre el array con el nombre de los valores a eliminar y los elimina
                deleteValues.forEach((valor) => {
                    delete valorObjeto[valor];
                });
            }
            // Objeto
        } else {
            //Paso 1. Recorre el array con el nombre de los valores a eliminar y los elimina
            deleteValues.forEach((valor) => {
                delete objeto[valor];
            });
        }
        return objeto;
    }
    
    /**
     * @constant mapearObjetoInteresado Mapeo del objeto interesado
     * @param {*} obj Objeto recibido
     * @returns 
     */
    const mapearObjetoInteresado = (obj) => {
        return {
            "id": obj.id,
            "nombre": obj.nombre,
            "apellido1": obj.apellido1,
            "apellido2": obj.apellido2,
            "nif": obj.identificador,
            "fechaNacimiento": obj.fechaNacimiento,
            "datosContacto": {
              "id": obj.idDatosContacto,
              "tipoVia": {
                "codigo": obj.codigoVia
              },
              "nombreVia": obj.nombreVia,
              "numero": obj.numero,
              "piso": obj.piso,
              "bloque": obj.bloque,
              "escalera": obj.escalera,
              "puerta": obj.puerta,
              "letra": obj.letra,
              "codigoPostal": obj.codPostal,
              "telefono": obj.telefono,
              "movil": obj.telefonoMovil,
              "email": obj.email
            },
            "tipoIdentificacion": {
              "codigo": obj.tipoIdentificador
            },
            "tipoNotificacion": obj.tipoNotificacion,
            "sexo": {
              "codigo": obj.sexo === "Hombre" ? "M" : "F",
              "descripcion": obj.sexo
            }
        }
    }

    /**
     * @function obtenerObjetoInteresadoPCT3 Obtención del objeto para insertar o actualizar interesado en la PCT3
     * @returns Objeto interesado
     */
    const obtenerObjetoInteresadoPCT3 = () => {        

        let provincia = values.provinciaDomicilioInteresado;
        let municipio = values.municipioDomicilioInteresado;

        addValuesObjetc(municipio, [{descripcion: municipio['descripcionCorta']}]);
        removeValuesObject(municipio, ['descripcionCorta']);
        addValuesObjetc(provincia, [{nombre: provincia['descripcionCorta']}]); 
        removeValuesObject(provincia, ['descripcionCorta']);

        //Interesado (interesado1)
        objInteresadoPCT3.interesado1.interesado.id = ((dataFrom === 'PCT3') ? values.idInteresado : '');
        objInteresadoPCT3.interesado1.interesado.nombre = values.nombreInteresado;
        objInteresadoPCT3.interesado1.interesado.apellido1 = values.apellido1Interesado;
        objInteresadoPCT3.interesado1.interesado.apellido2 = values.apellido2Interesado;
        // objInteresadoPCT3.interesado1.interesado.tipoIdentificador = values.tipoIdentificador;
        objInteresadoPCT3.interesado1.interesado.identificador = values.nifInteresado;
        objInteresadoPCT3.interesado1.interesado.sexo = JSON.parse(values.sexoInteresado).descripcion;
        objInteresadoPCT3.interesado1.interesado.fechaNacimiento = values.fechaNacimientoInteresado;
        //Datos de contacto interesado (interesado1)
        objInteresadoPCT3.interesado1.datosContacto.id = values.idDatoscontactoInteresado;
        objInteresadoPCT3.interesado1.datosContacto.tipoInteresado = values.tipoInteresado;
        objInteresadoPCT3.interesado1.datosContacto.tipoNotificacion = values.tipoNotificacion === '' || values.tipoNotificacion == undefined ? null : values.tipoNotificacion;
        objInteresadoPCT3.interesado1.datosContacto.tipoVia = values.tipoViaDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.nombreVia = values.nombreDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.numero = values.numeroDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.letra = values.letraDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.escalera = values.escaleraDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.piso = values.pisoDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.puerta = values.puertaDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.postal = values.codigoPostalDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.telefono = values.telefonoInteresado;
        objInteresadoPCT3.interesado1.datosContacto.telefonoMovil = values.telefonoMovilInteresado;
        objInteresadoPCT3.interesado1.datosContacto.email = values.emailInteresado;
        objInteresadoPCT3.interesado1.datosContacto.idPais = values.paisDomicilioInteresado.id;
        objInteresadoPCT3.interesado1.datosContacto.pais = values.paisDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.provincia = values.provinciaDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.municipio = values.municipioDomicilioInteresado;
        objInteresadoPCT3.interesado1.datosContacto.idProvincia = values.provinciaDomicilioInteresado.id;
        objInteresadoPCT3.interesado1.datosContacto.idMunicipio = values.municipioDomicilioInteresado.id;

        //Entidad representada (interesado2)
        if (values.cifEntidadRepresentada !== null) {
            objInteresadoPCT3.interesado2.interesado.id = ((dataFrom === 'PCT3') ? values.idEntidad : '');
            objInteresadoPCT3.interesado2.interesado.identificador = values.cifEntidadRepresentada;
            objInteresadoPCT3.interesado2.interesado.nombre = values.entidadRazonSocialEntidadRepresentada;
            //Datos de contacto de la entidad representada (interesado2)
            objInteresadoPCT3.interesado2.datosContacto.id = values.idDatoscontactoEntidad;
            objInteresadoPCT3.interesado2.datosContacto.tipoInteresado = values.tipoInteresado;
            objInteresadoPCT3.interesado2.datosContacto.tipoNotificacion = values.tipoNotificacion === '' || values.tipoNotificacion == undefined ? null : values.tipoNotificacion;
            objInteresadoPCT3.interesado2.datosContacto.tipoVia = values.tipoViaDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.nombreVia = values.nombreDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.numero = values.numeroDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.letra = values.letraDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.escalera = values.escaleraDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.piso = values.pisoDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.puerta = values.puertaDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.postal = values.codigoPostalDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.telefono = values.telefonoEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.telefonoMovil = values.telefonoMovilEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.email = values.emailEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.idPais = values.paisDomicilioEntidadRepresentada.id;
            objInteresadoPCT3.interesado2.datosContacto.pais = values.paisDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.provincia = values.provinciaDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.municipio = values.municipioDomicilioEntidadRepresentada;
            objInteresadoPCT3.interesado2.datosContacto.idProvincia = values.provinciaDomicilioEntidadRepresentada.id;
            objInteresadoPCT3.interesado2.datosContacto.idMunicipio = values.municipioDomicilioEntidadRepresentada.id;
        } else {
            objInteresadoPCT3.interesado2 = null;
        }
        
        return {...objInteresadoPCT3};
    }

    /**
     * @function modificarCodigoMunicipio Función que obtiene el código de municipio, tal y como se requiere en la PCT2
     * @param {*} municipio Objeto municipio
     * @returns Objeto municipio con los códigos de municipio y provinica modificados
     * Ambos códigos deben ser un String, el código de municipio debe contener 3 dígitos y el de provincia 2
     */
    const modificarCodigoMunicipio = (municipio) => {
        municipio.codigo = transformarCodigo(municipio.codigo, 3);
        municipio.provincia.codigo = transformarCodigo(municipio.provincia.codigo, 2);
        return municipio;
    }

    /**
     * @function transformarCodigo Función auxiliar para transformar el código recibido
     * @param {*} codigo Código recibido
     * @param {*} decimales Decimales a insertar
     * @returns Código transformado
     */
    const transformarCodigo = (codigo, decimales) => {
        let numDecimales = null;
    
        //Paso 1. Si el código no es un String, se convierte a String
        codigo = (typeof codigo !== 'string') ? codigo.toString() : codigo;
        
        //Paso 2. Obtención del número de decimales a insertar
        if (codigo.length > decimales) {
            numDecimales = codigo.length - decimales;
        } else if (codigo.length < decimales) {      
            numDecimales = decimales - codigo.length;
        } else {
            numDecimales = 0;
        }

        //Paso 3. Inserción de decimales
        if (numDecimales !== 0) {
          numDecimales = numDecimales === 2 ? '00' : '0';
        }

        //Paso 4. Transformación del código
        codigo = numDecimales === 0 ? codigo : numDecimales + codigo;
        return codigo;
    }
    
    const loadInfoCloud = async () => {
        await checkCloudProperties(100);
        let propMailDpd = propertiesCloudConfig['CONSEJERIA_MAIL_DPD'];
        setMailDPD(propMailDpd);
    } 

    return {
        //HandleChanges
        handleChange,
        obtenerObjetoUsuario, gotoElement, validarCamposObligatorios,
        //Values
        values, setValues, showAlert, setShowAlert,
        //validaciones
        emailValid, dniValid, cifValid, entidadRazonSocialEntidadRepresentadaValid, nombreValid, apellido1Valid, fechaValid, tlfValid, tlfMovilValid, sexoValid, codigoPostalInteresadoValid, 
        nombreDomicilioInteresadoValid, nombreProvinciaInteresadoValid, nombreMunicipioInteresadoValid, paisDomicilioInteresadoValid, descripcionTipoViaDomicilioInteresadoValid,
        numDomicilioInteresadoValid, numPisoInteresadoValid, tipoViaValidEntidad, nombreViaValidEntidad, pisoValidEntidad, numeroValidEntidad, provinciaValidEntidad, municipioValidEntidad,
        codigoPostalValidEntidad, emailValidEntidad, tlfValidEntidad, tlfMovilEntidad,
        //onBlur
        validationsOnBlur,
        //PCT3
        addValuesObjetc, removeValuesObject, mapearObjetoInteresado, obtenerObjetoInteresadoPCT3, setDataFrom, dataFrom,
        loadInfoCloud, mailDPD
        
    };

};
export default useForm;